import React from "react";

const LEVEL = {
  all_clear: { pill: "low", label: "All Clear", ic: "fa-shield-heart" },
  low: { pill: "low", label: "Low", ic: "fa-shield-halved" },
  medium: { pill: "medium", label: "Watch", ic: "fa-triangle-exclamation" },
  high: { pill: "high", label: "Warning", ic: "fa-tower-broadcast" },
};

const DOMAIN_BADGE = {
  normal: "badge-normal",
  watch: "badge-watch",
  elevated: "badge-elevated",
  critical: "badge-critical",
};

const DOMAINS = [
  { key: "weather", name: "Weather", icon: "fa-cloud-bolt" },
  { key: "marine", name: "Marine", icon: "fa-water" },
  { key: "seismic", name: "Seismic", icon: "fa-house-crack" },
  { key: "flood", name: "Flood", icon: "fa-house-flood-water" },
  { key: "fire", name: "Fire", icon: "fa-fire" },
];

const Reading = ({ label, value, unit }) => (
  <div className="hz-read">
    <div className="hz-rlab">{label}</div>
    <div className="hz-rval">{value == null ? "—" : value}{value != null && unit ? <span>{unit}</span> : null}</div>
  </div>
);

const recommendedAction = (level) => {
  if (level === "high") return "Pre-position units near exposed corridors and issue a public advisory.";
  if (level === "medium") return "Keep marine & flood-watch units on standby; advise motorists of surface water.";
  return "Maintain routine monitoring of all threat feeds.";
};

const HazardPanel = ({ hazards }) => {
  if (!hazards) return null;
  const lv = LEVEL[hazards.level] || LEVEL.all_clear;
  const r = hazards.readings || {};
  const domains = hazards.domains || {};
  const worstDomain = Object.values(domains).some((d) => d.level === "critical")
    ? "critical" : Object.values(domains).some((d) => d.level === "elevated") ? "elevated" : null;

  return (
    <div className="panel danger entrance" data-testid="threat-intel-panel">
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic" style={{ background: "linear-gradient(135deg,#013f82,#1e6ea7)" }}>
            <i className="fa-solid fa-shield-virus" />
          </div>
          Threat Intelligence
        </div>
        <span className={`pill ${lv.pill}`} data-testid="threat-level"><i className={`fa-solid ${lv.ic}`} /> {lv.label}</span>
      </div>

      <div className="threat-domains" data-testid="threat-domains">
        {DOMAINS.map((d) => {
          const dom = domains[d.key] || { level: "normal", label: "—", detail: "" };
          return (
            <div key={d.key} className={`threat-row lvl-${dom.level}`} data-testid={`threat-${d.key}`}>
              <div className="threat-ic"><i className={`fa-solid ${d.icon}`} /></div>
              <div className="threat-body">
                <div className="threat-top">
                  <span className="threat-name">{d.name}</span>
                  <span className={`badge ${DOMAIN_BADGE[dom.level] || "badge-normal"}`}>{dom.label}</span>
                </div>
                <div className="threat-detail">{dom.detail}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="threat-action" data-testid="threat-action">
        <i className="fa-solid fa-list-check" /> {recommendedAction(hazards.level)}
      </div>

      <div className="rr-sub" style={{ margin: "12px 0 8px" }}><i className="fa-solid fa-wave-square" /> Live monitored signals</div>
      <div className="hz-grid" data-testid="threat-readings">
        <Reading label="Waves" value={r.wave_height_m} unit="m" />
        <Reading label="Swell" value={r.swell_m} unit="m" />
        <Reading label="Gust (6h)" value={r.max_gust_kmh} unit="km/h" />
        <Reading label="Rain (6h)" value={r.max_precip_mm} unit="mm" />
      </div>
    </div>
  );
};

export default HazardPanel;
